import VueQrcode from '@chenfengyuan/vue-qrcode';
import { urlCombine } from 'BASE/common/util/util.apiProxy';

export default {
    data: function () {
        return {
            QrcodeOptions: {
                width: 150,
                margin: 1
            },
            iosUrl: '',
            androidUrl: '',
            GuideUrlIsComplete: false,
        };
    },
    components: {
        qrcode: VueQrcode
    },
    computed: {
        originURL: function () {
            var origin = "";
            if (!window.location.origin) {
                origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
            }
            else {
                origin = document.location.origin;
            }

            return ENVIRONMENT.CORDOVA? urlCombine("") : origin;
        }
    },
    methods: {
        AndroidOrPcFile(extension) {
            let merchantCode = typeof this.$store.state.userinfo.merchantCode == "string" ? this.$store.state.userinfo.merchantCode : "";

            if(merchantCode == "") return "javascript:void(0);";

            return `${this.originURL}/d/${merchantCode.toLowerCase()}/${merchantCode.toUpperCase()}.${extension}`;
        },
        FileName(fileName) {
            let merchantCode = typeof this.$store.state.userinfo.merchantCode == "string" ? this.$store.state.userinfo.merchantCode : "";

            if(merchantCode == "") return "javascript:void(0);";

            return `${this.originURL}/d/${merchantCode.toLowerCase()}/${fileName}`;
        },
        async Init() {
            let _this = this;
            _this.iosUrl = `${this.originURL}/IOSDownload`;
            _this.androidUrl = _this.AndroidOrPcFile("apk");
            try {

                let result = await $.get('/api/AFK/GetAFKConfig');
                if(result && result.IOSPlistPath && result.IOSPlistPath.indexOf(".plist") === -1 )
                {
                    _this.iosUrl = result.IOSPlistPath;
                }
                if(result && result.AndroidAPPUrl) {
                    _this.androidUrl = result.AndroidAPPUrl;
                }
                if(result.LegendAFKTelegramGuideUrl || result.LegendAFKVpnGuideUrl){
                    _this.GuideUrlIsComplete = true;
                }
            }
            catch (err) {
                console.error(err);
            }
        }
    },
    async mounted() {
        await this.Init();
    }
}